import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const University = lazy(() => import('../pages/university/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/university/:id',
    element: <University />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
